<app-cargando *ngIf="cargando"></app-cargando>

<div class="modal-header" style="height: 65px">
  <h4
    class="modal-title titulo-notadeventa"
    id="modal-basic-title"
    style="color: #91ca41"
  >
    <p>Crear/Editar Meta</p>
  </h4>

  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="cerrar()"
    style="color: white"
  >
    <span aria-hidden="true" style="color: #91ca41">&times;</span>
  </button>
</div>

<div class="row" style="margin: 0px; margin-top: 10px">

  <div class="col-12">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">SlpCode</span>
      </div>

      <select [(ngModel)]="data.SlpCode" disabled>
        <option *ngFor="let item of usuarios" [value]="item.VENDEDOR">{{item.VENDEDOR}}</option>
      </select>
    </div>
  </div>

  <div class="col-12">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">Nombre</span>
      </div>
      <select [(ngModel)]="data.SlpCode" (change)="aplicaNombre()">
        <option *ngFor="let item of usuarios" [value]="item.VENDEDOR">{{item.NOMBRE}}</option>
      </select>
  
    </div>
  </div>

  <div class="col-12">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">Mes</span>
      </div>
      <select [(ngModel)]="data.MES">
        <option value="1">Enero</option>
        <option value="2">Febrero</option>
        <option value="3">Marzo</option>
        <option value="4">Abril</option>
        <option value="5">Mayo</option>
        <option value="6">Junio</option>
        <option value="7">Julio</option>
        <option value="8">Agosto</option>
        <option value="9">Septiembre</option>
        <option value="10">Octubre</option>
        <option value="11">Noviembre</option>
        <option value="12">Diciembre</option>
      </select>

    </div>
  </div>

  <div class="col-12">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">Año</span>
      </div>
      
      <select [(ngModel)]="data.ANIO">
        <option value="2025">2025</option>
        <option value="2024">2024</option>
        <option value="2023">2023</option>
        <option value="2022">2022</option>
      </select>

    </div>
  </div>

  <div class="col-12">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">Valor</span>
      </div>
      <input
        type="number"
        class="form-control"
        placeholder=""
        aria-label="Username"
        aria-describedby="basic-addon1"
        [(ngModel)]="data.VALOR"
      />
    </div>
  </div>

</div>



<div class="modal-footer" style="height: 65px">


  <button mat-raised-button color="primary" style="margin-right: 5px;" (click)="cerrar()">Cerrar</button>

  <button *ngIf="!data._id" mat-raised-button color="primary" style="background: #91ca41;margin-right: 5px;" (click)="guardar()">Crear</button>
  <button *ngIf="data._id" mat-raised-button color="primary" style="background: #91ca41;margin-right: 5px;" (click)="guardar()">Actualizar</button>

</div>





